import CampusAttendance from '@/api/campus-attendance'
import ClassOperation from '@/api/class-operation'
import StudentProfile from '@/api/student-profile'
import MainProgram from '@/api/main-program'
import SubProgram from '@/api/sub-program'
import Year from '@/api/academic-year'
import Term from '@/api/term-semester'
import StudyTime from '@/api/study-time'
import { mapKeys, camelCase } from 'lodash'
import { baseState, baseMutations } from '@/store/mixins'

class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export const state = {
  ...baseState,
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES_SUMMARY(state, records) {
    const { data, ...meta } = records
    state.resources = data
    state.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
  },
}

export const actions = {
  fetchSummary(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return CampusAttendance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES_SUMMARY', response)
      return Promise.resolve(response)
    })
  },
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return CampusAttendance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  fetchMainProgram(context, attributes = {}) {
    return MainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  fetchSubProgram(context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acp_id,acps_id,acps_name_foreign'
          },
          filter: {
            acp_id: attributes.acp_id
          },

          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  fetchClasses(context, attributes = {}) {
    return ClassOperation.get({
      params: Object.assign(
        {
          page: -1,
          include: 'teacher,academic_study_time,branch',
          fields: {
            academic_classes: 'class_id,class_name,teacher_resp_id,ac_st_id,branch_id'
          },
          filter: {
            acp_id: attributes.acp_id,
            acps_id: attributes.acps_id
          },
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  fetchStudents(context, attributes = {}) {
    return StudentProfile.get({
      params: {
        page: -1,
        acps_id: attributes.acps_id,
        fields: {
          setup_student_profiles:
            'student_id,first_name_kh,last_name_kh,first_name_en,last_name_en,card_number,ext_card_number'
        },
        filter: {
          student_in_class: attributes.class_id
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  async getStudentStatus(context) {
    return StudentProfile.getStatus()
  },
  // Export Excel
  exportExcel(context, data) {
    return CampusAttendance.exportExcel(data)
  },
  store(context, data) {
    return CampusAttendance.store(data)
  },
  getHeader(context, params) {
    return CampusAttendance.header({ params })
  },
  getYear(context, attributes = {}) {
    return Year.get({
      params: Object.assign(
        {
          include: 'branch',
          fields: {
            academic_years: 'ac_year_id,ac_year,ac_status_id,branch_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getTerm(context, attributes = {}) {
    return Term.get({
      params: Object.assign(
        {
          include: 'branch',
          fields: {
            academic_terms: 'ac_term_id,term_name,ac_status_id,term_order,branch_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getStudyTime(context, attributes = {}) {
    return StudyTime.get({
      params: Object.assign(
        {
          fields: {
            academic_study_times: 'ac_st_id,study_time,session'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getLatestCheckIn(context, studentId) {
    return CampusAttendance.latestCheckIn(studentId);
  },
  destroy(context, params) {
    return CampusAttendance.destroy(params.student_id, params.datescan)
  }
}
